import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-9494cbc2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "main-container" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "left-container" }, null, -1));
const _hoisted_3 = { class: "center-container" };
const _hoisted_4 = {
    id: "MainTitle",
    class: "text-lg sm:text-xl md:text-2xl"
};
const _hoisted_5 = { class: "text-sm sm:text-base md:text-lg text-gray-500" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_7 = { class: "right-container" };
const _hoisted_8 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_hit_input = _resolveComponent("hit-input");
    const _component_hit_form = _resolveComponent("hit-form");
    const _component_hit_panel = _resolveComponent("hit-panel");
    const _component_hit_button = _resolveComponent("hit-button");
    const _component_hit_banner = _resolveComponent("hit-banner");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('admin-ui.personal_information_form_personal_information')), 1),
                _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.t('admin-ui.personal_information_form_explanation_part_1')), 1),
                _hoisted_6,
                _createVNode(_component_hit_panel, {
                    size: "maximized",
                    resizable: false
                }, {
                    body: _withCtx(() => [
                        _createVNode(_component_hit_form, {
                            name: "contactInformationForm",
                            value: _ctx.contactInformationData,
                            validations: _ctx.validations,
                            "force-cancel-button-hidden": true,
                            "force-save-button-hidden": true
                        }, {
                            default: _withCtx(({ formData, validationState }) => [
                                _createVNode(_component_hit_input, {
                                    name: "email",
                                    class: "text-sm sm:text-base",
                                    value: _ctx.userRetrievedData.email,
                                    label: _ctx.t('admin-ui.email'),
                                    disabled: true
                                }, null, 8, ["value", "label"]),
                                _createVNode(_component_hit_input, {
                                    name: "firstName",
                                    class: "text-sm sm:text-base",
                                    disabled: _ctx.userRetrievedData.first_name,
                                    value: formData.firstName,
                                    "validation-state": validationState.firstName,
                                    label: _ctx.t('admin-ui.first_name'),
                                    onInput: _ctx.onChangeFirstName
                                }, null, 8, ["disabled", "value", "validation-state", "label", "onInput"]),
                                _createVNode(_component_hit_input, {
                                    name: "lastName",
                                    class: "text-sm sm:text-base",
                                    disabled: _ctx.userRetrievedData.last_name,
                                    value: formData.lastName,
                                    "validation-state": validationState.lastName,
                                    label: _ctx.t('admin-ui.last_name'),
                                    onInput: _ctx.onChangeLastName
                                }, null, 8, ["disabled", "value", "validation-state", "label", "onInput"]),
                                (!_ctx.userRetrievedData.hide_password)
                                    ? (_openBlock(), _createBlock(_component_hit_input, {
                                        key: 0,
                                        name: "password",
                                        class: "text-sm sm:text-base",
                                        type: _ctx.inputPasswordType,
                                        "show-toggle-password": true,
                                        value: formData.password,
                                        "validation-state": validationState.password,
                                        label: _ctx.t('admin-ui.password'),
                                        "inline-input": "",
                                        onPasswordVisibilityChange: _ctx.switchPasswordVisibility,
                                        onInput: _ctx.onChangePassword
                                    }, null, 8, ["type", "value", "validation-state", "label", "onPasswordVisibilityChange", "onInput"]))
                                    : _createCommentVNode("", true),
                                (!_ctx.userRetrievedData.hide_password)
                                    ? (_openBlock(), _createBlock(_component_hit_input, {
                                        key: 1,
                                        name: "confirmPassword",
                                        class: "text-sm sm:text-base",
                                        type: _ctx.inputConfirmPasswordType,
                                        "show-toggle-password": true,
                                        value: formData.confirmPassword,
                                        "validation-state": validationState.confirmPassword,
                                        label: _ctx.t('admin-ui.confirm_password'),
                                        "inline-input": "",
                                        onInput: _ctx.onChangeConfirmPassword,
                                        onPasswordVisibilityChange: _ctx.switchConfirmPasswordVisibility
                                    }, null, 8, ["type", "value", "validation-state", "label", "onInput", "onPasswordVisibilityChange"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }, 8, ["value", "validations"])
                    ]),
                    _: 1
                })
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_hit_button, {
                    color: "accent",
                    disabled: !_ctx.valueAllowNextClick,
                    "suffix-icon": "forward",
                    "icon-size": "lg",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('nextClick', {
                        email: _ctx.userRetrievedData.email,
                        password: _ctx.contactInformationData.password,
                        confirmPassword: _ctx.contactInformationData.confirmPassword,
                        lastName: _ctx.contactInformationData.lastName,
                        firstName: _ctx.contactInformationData.firstName,
                        referralCode: _ctx.contactInformationData.referralCode,
                    })))
                }, null, 8, ["disabled"])
            ])
        ]),
        (_ctx.showBanner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_hit_banner, {
                    "show-animation": _ctx.showAnimationBanner,
                    onClose: _cache[1] || (_cache[1] = ($event) => (_ctx.closeBanner()))
                }, {
                    "dynamic-content": _withCtx(() => [
                        _createElementVNode("h6", null, _toDisplayString(_ctx.textBanner), 1)
                    ]),
                    _: 1
                }, 8, ["show-animation"])
            ]))
            : _createCommentVNode("", true)
    ]));
}
